import { render, staticRenderFns } from "./newok.vue?vue&type=template&id=2663f2a6&scoped=true&"
import script from "./newok.vue?vue&type=script&lang=js&"
export * from "./newok.vue?vue&type=script&lang=js&"
import style0 from "./newok.vue?vue&type=style&index=0&id=2663f2a6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2663f2a6",
  null
  
)

export default component.exports